import { render, staticRenderFns } from "./preferences.html?vue&type=template&id=2a2dd43d&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports